var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6933 1.61056L10.7667 0.397222C10.5867 0.151667 10.3133 0 10 0H2C1.68667 0 1.41333 0.151667 1.22667 0.397222L0.306667 1.61056C0.113333 1.85611 0 2.18111 0 2.52778V11.5556C0 12.35 0.6 13 1.33333 13H10.6667C11.4 13 12 12.35 12 11.5556V2.52778C12 2.18111 11.8867 1.85611 11.6933 1.61056ZM2.16 1.44444H9.84L10.3933 2.16667H1.61333L2.16 1.44444ZM1.33333 11.5556V3.61111H10.6667V11.5556H1.33333ZM3.33333 7.94444H5.03333V10.1111H6.96667V7.94444H8.66667L6 5.05556L3.33333 7.94444Z",
    fill: "#F5B309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.195fbf06b04cf5ba63bb77497d599eb4.svg";
export { ForwardRef as ReactComponent };